import React, { forwardRef, Fragment, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { useQueryState } from 'use-location-state'
import { Button, Col, Modal, ModalBody, NavLink, Row, CustomInput } from 'reactstrap'
import PropTypes from 'prop-types'
import qs from 'query-string'
import moment from 'moment'

import sortIcon from '../../../assests/images/sorting-icon.svg'
// import viewIcon from '../../../assests/images/view-icon.svg'
// import checkIcon from '../../../assests/images/check-round-icon.svg'
import warningIcon from '../../../assests/images/warning-icon.svg'

import SkeletonTable from '../../../components/SkeletonTable'
import ToastMessage from '../../../components/Toast'
import { clearUserExportData, getUserList, updateUser } from '../../../actions/user'

const AdminUserManagement = forwardRef((props, ref) => {
  const exporter = useRef(null)
  const [list, setList] = useState([])
  const [order, setOrder] = useQueryState('order', 'desc')
  const [activePageNo, setPageNo] = useQueryState('page', 1)
  const [offset, setOffset] = useQueryState('pageSize', 10)
  const [search, setSearch] = useQueryState('search', '')
  const [startDate, setStartDate] = useQueryState('startDate', '')
  const [endDate, setEndDate] = useQueryState('endDate', '')
  const [loading, setLoading] = useState(false)
  const [alert] = useState(null)
  const [type, setType] = useState('')
  const [selectedData, setSelectedData] = useState({})
  const [sortBy, setSortBy] = useQueryState('sortBy', 'dCreatedAt')
  const [usernameOrder, setUsernameOrder] = useState('desc')
  const [createdOrder, setCreatedOrder] = useState('desc')
  const [message, setMessage] = useState('')
  const [status, setStatus] = useState('')


  const [modalMessage, setModalMessage] = useState(false)
  const toggleMessage = () => setModalMessage(!modalMessage)
  const [modalWarning, setModalWarning] = useState(false)
  const toggleWarning = () => setModalWarning(!modalWarning)

  const dispatch = useDispatch()
  const searchProp = props?.search
  const openPickerProp = props?.openPicker
  const startDateProp = props?.startDate
  const endDateProp = props?.endDate

  const token = useSelector(state => state?.auth?.token)
  const userList = useSelector(state => state?.user?.userList)
  const resStatus = useSelector((state) => state?.user?.resStatus)
  const resMessage = useSelector((state) => state?.user?.resMessage)
  const previousProps = useRef({
    userList, openPickerProp, searchProp, startDateProp, endDateProp 
  })?.current


  useEffect(() => {
    if (props?.location?.state) {
      if (props?.location?.state?.message) {
        setMessage(props?.location?.state?.message)
        setStatus(true)
        setModalMessage(true)
      }
      props.history.replace()
    }
    let sortbyvalue = 'dCreatedAt'
    const orderVal = 'desc'
    const page = 1
    const limit = offset
    const obj = qs?.parse(props?.location?.search)
    if (obj) {
      setPageNo(obj?.page || page)
      setOffset(obj?.pageSize || limit)
      setOrder(obj?.order || orderVal)
      if (obj?.sortBy) {
        setCreatedOrder(obj?.order)
      } else {
        setUsernameOrder(obj?.order)
      }
      if (obj?.sortBy) {
        sortbyvalue = obj?.sortBy
        setSortBy(sortbyvalue)
      }
    }
    const start = ((obj?.page || page) - 1) * (obj?.pageSize || limit)
    dispatch(getUserList(start, obj.pageSize || limit, orderVal, search, startDate, endDate, sortbyvalue, false, 'O',token))
    setLoading(true)

    return () => {
      dispatch(clearUserExportData())
    }
  }, [])

  useEffect(() => {
    if (previousProps?.userList !== userList) {
      if (userList) {
        setList(userList?.users || [])
      }
      setLoading(false)
    }
    return () => {
      previousProps.userList = userList
    }
  }, [userList])

  useEffect(() => {
    const callSearchService = () => {
      const start = 0
      const limit = offset
      dispatch(getUserList(start, limit, order, searchProp, startDate, endDate, sortBy, false, 'O', token))
      setSearch(searchProp)
      setPageNo(1)
      setLoading(true)
    }
    if (previousProps?.searchProp !== searchProp && props.flag) {
      const debouncer = setTimeout(() => {
        callSearchService()
      }, 1000)
      return () => {
        clearTimeout(debouncer)
        previousProps.searchProp = searchProp
      }
    }
    return () => {
      previousProps.searchProp = searchProp
    }
  }, [searchProp])

  useEffect(() => {
    if (previousProps?.resMessage !== resMessage) {
      if (resMessage) {
        if (resStatus) {
          const start = 0
          const limit = offset
          dispatch(getUserList(start, limit, order, searchProp, startDate, endDate, sortBy, false, 'O', token))
          setMessage(resMessage)
          setStatus(resStatus)
          setModalMessage(true)
          setModalWarning(false)
        } else {
          setMessage(resMessage)
          setStatus(resStatus)
          setModalWarning(false)
          setModalMessage(true)
          setLoading(false)
        }
      }
    }
    return () => {
      previousProps.resMessage = resMessage
    }
  }, [resStatus, resMessage])

  function onSorting (sortingBy) {
    const Order = sortingBy === 'sUsername' ? usernameOrder : createdOrder
    if (Order === 'asc') {
      const start = 0
      const limit = offset
      dispatch(getUserList(start, limit, 'desc', search, startDate, endDate, sortingBy, false, 'O', token))
      setOrder('desc')
      setPageNo(1)
      setLoading(true)
      if (sortingBy === 'sUsername') {
        setUsernameOrder('desc')
        setSortBy(sortingBy)
      } else {
        setCreatedOrder('desc')
        setSortBy(sortingBy)
      }
    } else {
      const start = 0
      const limit = offset
      dispatch(getUserList(start, limit, 'asc', search, startDate, endDate, sortingBy, false, 'O', token))
      setOrder('asc')
      setPageNo(1)
      setLoading(true)
      if (sortingBy === 'sUsername') {
        setUsernameOrder('asc')
        setSortBy(sortingBy)
      } else {
        setCreatedOrder('asc')
        setSortBy(sortingBy)
      }
    }
  }

  function warningWithConfirmMessage (data, eType) {
      setType(eType)
      setSelectedData(data)
      setModalWarning(true)
    
  }

  function onStatusUpdate () {
    const toggleStatus = selectedData?.eStatus === 'Y' ? 'B' : 'Y'
    const updateUserData = {
      eStatus : toggleStatus
    }
    const ID= selectedData?._id
    dispatch(updateUser(updateUserData,token,ID))
    setLoading(true)
    toggleWarning()
    setSelectedData({})
  }

  return (
    <Fragment>
    {alert}
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Sr no.</th>
              <th>
                <span className="d-inline-block align-middle">Username</span>
                <Button color="link" className="sort-btn" onClick={() => onSorting('sUsername')}><img src={sortIcon} className="m-0" alt="sorting" /></Button>
              </th>
              <th>Email</th>
              <th>Mobile No</th>
              <th>
                <span className="d-inline-block align-middle">Registration Date</span>
                <Button color="link" className="sort-btn" onClick={() => onSorting('dCreatedAt')}><img src={sortIcon} className="m-0" alt="sorting" /></Button>
              </th>
              <th>Events Created</th>
              <th>Events Played</th>
              <th>Status</th>
              {/* <th>Action</th> */}
            </tr>
          </thead>
          <tbody>
            {loading
              ? <SkeletonTable numberOfColumns={8} />
              : (
                <Fragment>
                  {list && list?.length !== 0 &&list?.map((data, i) => (
                      <tr key={data?._id}>
                        <td>{(((activePageNo - 1) * offset) + (i + 1))}</td>
                        <td><NavLink to={'/users/usermanagement/view/' + data?._id}>{data?.sUsername}</NavLink></td>
                        <td>{data?.sEmail || '--'}</td>
                        <td>{data?.sMobNum || '--'}</td>
                        <td>{moment(data?.dCreatedAt)?.local()?.format('lll')}</td>
                        <td>{data?.oStats?.nContestCreated}</td>
                        <td>{data?.oStats?.nContestCreated}</td>
                        <td>
                        <CustomInput
                            type='switch'
                            id={`${data?._id}`}
                            key={`${data?._id}`}
                            name={`${data?._id}`}
                            checked={data?.eStatus === 'Y'}
                            onClick={() =>warningWithConfirmMessage(data,data?.eStatus === 'Y' ? 'Deactivate' : 'Activate')}
                          />
                        </td>
                      </tr>
                    ))
                  }
                </Fragment>
                )}
          </tbody>
        </table>
      </div>
      {!list && !loading &&(
          <div className="text-center">
            <h3>No Users available</h3>
          </div>
      )}

      {/* {!!userList?.results?.length && (<PaginationComponent items={userList} onPageChange={onPageChange} />)} */}
      {/* <Modal isOpen={openPickerProp}>
        <ModalBody>
          <DateRangePicker className="mb-4" ranges={[selectionRange]} onChange={handleSelect} />
          <Row>
            <Col>
              <Button className="theme-btn success-btn full-btn" data-dismiss="modal" type="button" onClick={onConfirmRange}>Confirm</Button>
            </Col>
            <Col>
              <Button className="theme-btn danger-btn full-btn" data-dismiss="modal" type="button" onClick={onClose}>Close</Button>
            </Col>
            <Col>
              <Button className="theme-btn warning-btn full-btn" data-dismiss="modal" type="button" onClick={onReset}>Reset</Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal> */}

      <Modal isOpen={modalWarning} toggle={toggleWarning} className="modal-confirm">
        <ModalBody className='text-center'>
          <img className='info-icon' src={warningIcon} alt='check' />
          <h2>{`Are you sure you want to ${type} it?`}</h2>
          <Row className='row-12'>
            <Col>
              <Button type='submit' className='theme-btn outline-btn full-btn' onClick={toggleWarning}>Cancel</Button>
            </Col>
            <Col>
              <Button type='submit' className='theme-btn danger-btn full-btn' onClick={onStatusUpdate}>{`Yes, ${type} it`}</Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      

      <ToastMessage
        onToggle={toggleMessage}
        isSuccess={true}
        isVisible={modalMessage}
        message={message}
      />
    </Fragment>
  )
})
AdminUserManagement.propTypes = {
  location: PropTypes.object,
  search: PropTypes.string,
  openPicker: PropTypes.bool,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  handleDateRangePicker: PropTypes.func,
  flag: PropTypes.bool,
  history: PropTypes.object
}

AdminUserManagement.displayName = AdminUserManagement
export default connect(null, null, null, { forwardRef: true })(AdminUserManagement)
